import {
  ATTENDEESNETWORK_MSGSENT, // Do not delete It (Importing it from Attendees Networking)
  ATTENDEESNETWORK_PROFVIEW,
  ATTENDEESNETWORK_ATTESEAR,
  ATTENDEESNETWORK_ATTEFAVO,
  ATTENDEESNETWORK_SCANS,
  ATTENDEESNETWORK_ITEM_SELECTED,
  ATTENDEESNETWORK_POPUATTEN_TABLELIST,
  ATTENDEESNETWORK_MSTACTVATTEN_TABLELIST,
  ATTENDEESNETWORK_MOSTSEARKEYS_TABLELIST,
  ATTENDEESNETWORK_ENGAGEMENT_BARCHART,
} from "AttendeesnetworkActions";

export var AttendeesNetworkMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: ATTENDEESNETWORK_PROFVIEW,
      iconName: "profview",
      sectionName: "Attendee's profile views",
      sectionDesc:
        "Number of users who browsed through the attendees's profiles",
      selected: false,
    },
    {
      key: ATTENDEESNETWORK_ATTESEAR,
      iconName: "attesear",
      sectionName: "Attendees searches",
      sectionDesc: "Number of search done on the attendees list",
      selected: false,
    },
    {
      key: ATTENDEESNETWORK_ATTEFAVO,
      iconName: "attefavo",
      sectionName: "Attendee favourites",
      sectionDesc: "Number of bookmarked attendees profiles",
      selected: false,
    },
    {
      key: ATTENDEESNETWORK_SCANS,
      iconName: "scans",
      sectionName: "Scans",
      sectionDesc: "Number of attendee to attendee QR scans done in the app",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;
  return state;
};

// Initial select tab is "ATTENDEESNETWORK_PROFVIEW"
export var AttendeesnetworkSelectedItem = (
  state = ATTENDEESNETWORK_PROFVIEW,
  action
) => {
  if (action.type == ATTENDEESNETWORK_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};

// Local reducers for Popular Attendees (Attendees who received the most networking actions from the other app users)
export var AttendeesnetworkPopuattenTablelist = (state = {}, action) => {
  switch (action.type) {
    case ATTENDEESNETWORK_POPUATTEN_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for Most Active networks (Attendees who made the most networking actions from the other app users)
export var AttendeesnetworkMstactvattenTablelist = (state = {}, action) => {
  switch (action.type) {
    case ATTENDEESNETWORK_MSTACTVATTEN_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for most search keywords related to attendees netword
export var AttendeesnetworkMostsearkeysTablelist = (state = {}, action) => {
  switch (action.type) {
    case ATTENDEESNETWORK_MOSTSEARKEYS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducer for {Network Engagement (Chart view of how active users has been using the networking feature of the app over the selected date range)}

export const AttendeesnetworkEngagementbarChart = (state = {}, action) => {
  switch (action.type) {
    case ATTENDEESNETWORK_ENGAGEMENT_BARCHART:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};
